const pageModule = {
    namespaced: true,
    state: {
        appColor: 'primary',
        appHeaderName: 'โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน',
        appHeaderName1: 'จัดโครงการ/ค่าใช้จ่ายอื่น',
        appHeaderName2: 'อบรม / เดินทางไปปฏิบัติงาน',
        appDialogLoading: true,
        projPlanMenu: '1',
    },
    mutations: {
        SET_APPCOLOR(state, data) {
            state.appColor = data
        },
        SET_HEADERNAME(state, data) {
            state.appHeaderName = data
        },
        SET_DIALOG_LOADING(state, data) {
            state.appDialogLoading = data
        },
        SET_PROJPLANMENU(state, data) {
            state.projPlanMenu = data
        },
    },
    actions: {
        changeColor({ commit }, data) {
            commit('SET_APPCOLOR', data.color)
        },
        changeHeaderName({ commit }, data) {
            commit('SET_HEADERNAME', data.headerName)
        },
        changeDialogLoading({ commit }, data) {
            commit('SET_DIALOG_LOADING', data.loading)
        },
        changeProjPlanMenu({ commit }, data) {
            commit('SET_PROJPLANMENU', data.projPlanMenu)
        },
    },
    getters: {
        getColor(state){
            return state.appColor
        },
        getHeaderName(state){
            return state.appHeaderName
        },
        getDialogLoading(state){
            return state.appDialogLoading
        },
        getProjPlanMenu(state){
            return state.projPlanMenu
        },
    }
}

export default pageModule
